import { Link } from "react-router-dom";
import { withLayout } from "../../components/feature/PageLayout";
import SEOHead from "../../components/feature/SEOHead";

const siteUrl = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

const services = [
  {
    tag: "核心課程",
    title: "芳香創富系統課程",
    subtitle: "從零開始打造芳香收入體系",
    modules: [
      "心態調頻：建立自信與行動節奏，啟動 90 天目標",
      "精油應用：療癒日常四情境（睡眠 / 情緒 / 專注 / 居家）",
      "分享話術：從體驗到成交的溫暖溝通與諮詢流程",
      "複製流程：工具化腳本與內容矩陣，帶人帶隊",
    ],
    extras: [
      "用香氣療癒，建立身心平衡的力量",
      "學習簡單可複製的創業流程",
      "建立屬於你的彈性收入與女力品牌",
    ],
    quote:
      "我相信：「當你被香氣滋養，你的人生也將被豐盛包圍。」這就是——讓香氣，帶你遇見更好的自己與人生。",
    expansions: [
      "1 對 1 指導 & 團體教練",
      "芳香冥想工作坊 / 靈性金錢課程",
      "女力品牌孵化器",
      "VIP 芳療創富俱樂部",
    ],
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20teaching%20a%20small%20group%2C%20essential%20oil%20bottles%20and%20learning%20materials%20on%20table%2C%20warm%20bright%20workshop%20space%2C%20professional%20yet%20warm%20atmosphere%2C%20cream%20and%20amber%20tones%2C%20feminine%20education%20photography&width=800&height=600&seq=coach-svc-01&orientation=landscape",
  },
  {
    tag: "主題班",
    title: "女性創業教練班",
    subtitle: "主題：身心靈整合 × 女力創業",
    features: [
      "30 天挑戰營：每日任務與回饋，養成行動肌肉",
      "財富轉化手帳：金錢心態 × 目標拆解 × KPI 追蹤",
      "線上社群輔導：每週小組教練 / Live 問答",
    ],
    image: "https://readdy.ai/api/search-image?query=Woman%20journaling%20at%20a%20peaceful%20desk%20with%20crystals%20and%20essential%20oils%2C%20morning%20sunlight%2C%20mindfulness%20and%20planning%20vibe%2C%20cream%20and%20beige%20tones%2C%20feminine%20personal%20development%20photography&width=800&height=600&seq=coach-svc-02&orientation=landscape",
  },
  {
    tag: "企業 / 團隊",
    title: "團隊培訓與授權系統",
    subtitle: "帶領新團隊、建立領導人系統課程",
    features: [
      "教材包：腳本、培訓簡報、行動清單",
      "教練認證：分級培訓與考核標準",
      "授權培訓：系統導入與 KPI 輔導",
    ],
    image: "https://readdy.ai/api/search-image?query=Professional%20woman%20presenting%20to%20a%20team%20in%20a%20modern%20meeting%20room%2C%20whiteboard%20with%20diagrams%2C%20confident%20leadership%2C%20warm%20natural%20lighting%2C%20cream%20and%20beige%20interior%2C%20corporate%20training%20photography&width=800&height=600&seq=coach-svc-03&orientation=landscape",
  },
  {
    tag: "會員制",
    title: "VIP 芳療創富俱樂部",
    subtitle: "每月主題香氣盒＋直播課程＋團隊資源",
    features: [
      "每月主題香氣盒：配方卡＋儀式指南",
      "會員直播：精油應用 × 創富心法 × 領導訓練",
      "資源庫：教材、腳本、案例模板持續更新",
    ],
    image: "https://readdy.ai/api/search-image?query=Luxurious%20subscription%20box%20with%20essential%20oil%20bottles%2C%20beautiful%20recipe%20cards%2C%20dried%20flowers%20and%20a%20silk%20ribbon%2C%20warm%20soft%20lighting%2C%20cream%20and%20gold%20tones%2C%20premium%20unboxing%20photography%20with%20elegant%20flat%20lay&width=800&height=600&seq=coach-svc-04&orientation=landscape",
  },
];

function Coaching() {
  return (
    <>
      <SEOHead
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "教練服務與課程",
          "description": "芳香創富系統課程、女性創業教練班、團隊培訓與 VIP 芳療創富俱樂部",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Course",
                "name": "芳香創富系統課程",
                "description": "從零開始打造芳香收入體系，學習心態調頻、精油應用、分享話術與複製流程。"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Course",
                "name": "女性創業教練班",
                "description": "身心靈整合 × 女力創業，30 天挑戰營與線上社群輔導。"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Course",
                "name": "團隊培訓與授權系統",
                "description": "帶領新團隊、建立領導人系統課程，含教材包與教練認證。"
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Course",
                "name": "VIP 芳療創富俱樂部",
                "description": "每月主題香氣盒＋直播課程＋團隊資源。"
              }
            }
          ]
        }}
      />
      {/* Hero */}
      <section className="relative w-full h-[350px] md:h-[460px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20woman%20coaching%20another%20woman%20in%20a%20beautiful%20airy%20room%2C%20essential%20oil%20display%20and%20learning%20materials%2C%20warm%20natural%20light%20from%20large%20windows%2C%20supportive%20mentoring%20atmosphere%2C%20cream%20and%20amber%20tones%2C%20professional%20coaching%20photography&width=1800&height=800&seq=coach-hero-bg&orientation=landscape"
          alt="教練服務與課程"
          title="香氛女王的幸福大地 教練服務與課程"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
        <div className="relative z-10 w-full max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h1 className="text-[2rem] md:text-[2.75rem] font-bold text-white leading-[1.3] mb-3 md:mb-4">
            教練服務 / 課程
          </h1>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] max-w-[680px] mx-auto">
            從零開始打造芳香收入體系，承接多元變現；用香氣 × 系統 ×
            領導力，一起走向更自由的生活選擇。
          </p>
        </div>
      </section>

      {/* Service Cards */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          {/* Card 1 - Main */}
          <div className="bg-white rounded-[18px] overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.06)] mb-8">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-[45%] h-[280px] lg:h-auto overflow-hidden">
                <img
                  src={services[0].image}
                  alt={services[0].title}
                  title={services[0].title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="lg:w-[55%] p-6 md:p-8">
                <span className="inline-block text-[1rem] font-medium text-primary-700 bg-primary-100/70 rounded-full px-2.5 py-0.5 mb-3">
                  {services[0].tag}
                </span>
                <h2 className="text-[1.5rem] md:text-[1.625rem] font-bold text-foreground-950 leading-[1.4] mb-1.5">
                  {services[0].title}
                </h2>
                <p className="text-[1.1875rem] text-foreground-600 leading-[1.75] mb-4">
                  {services[0].subtitle}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                  {services[0].modules.map((m, i) => (
                    <div key={i} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                      <span className="text-[1rem] text-foreground-700 leading-[1.55]">
                        {m}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="mb-4">
                  <p className="text-[1.0625rem] font-medium text-foreground-950 mb-2">
                    在「芳香創富系統」中，我將帶你：
                  </p>
                  <ul className="space-y-1.5">
                    {services[0].extras.map((e, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-2 text-[1rem] text-foreground-600 leading-[1.55]"
                      >
                        <i className="ri-star-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                        <span>{e}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="text-[1.0625rem] italic text-secondary-500 leading-[1.6] mb-4">
                  {services[0].quote}
                </p>
                <div className="mb-4">
                  <p className="text-[1rem] font-medium text-foreground-950 mb-2">
                    拓展多元變現，承接更多收入來源：
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {services[0].expansions.map((ex, i) => (
                      <span
                        key={i}
                        className="inline-block text-[1rem] text-foreground-600 bg-background-200/70 rounded-full px-3 py-1.5"
                      >
                        {ex}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
                  >
                    報名課程
                  </Link>
                  <a
                    href="https://line.me/R/ti/p/@your-id"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center justify-center px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition-colors duration-200"
                  >
                    加入 LINE@
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Cards 2-4 */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
            {services.slice(1).map((svc) => (
              <div
                key={svc.title}
                className="bg-white rounded-[18px] overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.06)] flex flex-col"
              >
                <div className="w-full h-[200px] md:h-[230px] overflow-hidden">
                  <img
                    src={svc.image}
                    alt={svc.title}
                    title={svc.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 md:p-6 flex-1 flex flex-col">
                  <span className="inline-block text-[1rem] font-medium text-accent-700 bg-accent-100/70 rounded-full px-2.5 py-0.5 mb-3 self-start">
                    {svc.tag}
                  </span>
                  <h3 className="text-[1.25rem] md:text-[1.375rem] font-semibold text-foreground-950 leading-[1.5] mb-1.5">
                    {svc.title}
                  </h3>
                  <p className="text-[1.0625rem] text-foreground-600 leading-[1.6] mb-4">
                    {svc.subtitle}
                  </p>
                  <ul className="space-y-2 mb-5 flex-1">
                    {svc.features.map((f, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-2 text-[1rem] text-foreground-600 leading-[1.55]"
                      >
                        <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center px-6 py-2.5 rounded-full text-[1rem] font-medium whitespace-nowrap cursor-pointer border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition-colors duration-200 self-start"
                  >
                    {svc.tag === "企業 / 團隊"
                      ? "申請導入"
                      : svc.tag === "會員制"
                        ? "加入會員"
                        : "報名課程"}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom Form */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
            <div className="lg:w-[60%]">
              <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-2">
                想了解哪個方案最適合妳？
              </h2>
              <p className="text-[1.1875rem] text-foreground-600 leading-[1.75] mb-6">
                填寫表單，收到課綱與開課通知。
              </p>
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d8pdsevij7vns5otj8r0"
                method="POST"
                className="space-y-4"
              >
                <div>
                  <label
                    htmlFor="coach-name"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    姓名
                  </label>
                  <input
                    id="coach-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="請輸入您的姓名"
                  />
                </div>
                <div>
                  <label
                    htmlFor="coach-email"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    Email
                  </label>
                  <input
                    id="coach-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="請輸入您的 Email"
                  />
                </div>
                <div>
                  <label
                    htmlFor="coach-plan"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    想了解的方案
                  </label>
                  <select
                    id="coach-plan"
                    name="plan"
                    required
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 focus:outline-none focus:border-primary-500 transition-colors cursor-pointer appearance-none"
                  >
                    <option value="">請選擇</option>
                    <option value="芳香創富系統課程">芳香創富系統課程</option>
                    <option value="女性創業教練班">女性創業教練班</option>
                    <option value="團隊培訓與授權系統">
                      團隊培訓與授權系統
                    </option>
                    <option value="VIP芳療創富俱樂部">
                      VIP 芳療創富俱樂部
                    </option>
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="coach-goal"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    妳的現況 / 目標{" "}
                    <span className="text-foreground-600 font-normal">
                      （選填）
                    </span>
                  </label>
                  <textarea
                    id="coach-goal"
                    name="goal"
                    rows={3}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                    placeholder="請簡單描述您的現況或目標"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-8 py-3.5 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
                >
                  送出表單
                </button>
              </form>
            </div>
            <div className="lg:w-[40%]">
              <div className="bg-secondary-500 rounded-[18px] p-6 md:p-8 h-full flex flex-col justify-center">
                <h3 className="text-[1.25rem] font-semibold text-white mb-3">
                  還在猶豫嗎？
                </h3>
                <p className="text-[1.1875rem] text-white/80 leading-[1.75] mb-5">
                  加入 LINE
                  官方社群，觀看學員見證與課程花絮，先感受再決定。
                </p>
                <a
                  href="https://line.me/R/ti/p/@your-id"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-white/40 text-white hover:bg-white/10 transition-colors duration-200"
                >
                  加入 LINE@ <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withLayout(Coaching);